<template>
  <div>
    <div class="common-form">租赁设置</div>
    
    <div class="addfenqi">
      <el-table :data="form.model.tableData" height="500" border style="width: 700px;">
        <el-table-column prop="lease_time" label="租赁月数" width="180">
        </el-table-column>
        <el-table-column prop="val" label="租完买断比例%" width="180">
        </el-table-column>
        <el-table-column prop="value" label="租完即送比例%" width="180">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="intext">
        <div class="item">
          <div class="div">租赁月数：</div>
          <el-input v-model="lease_time" placeholder="请输入租赁月数"></el-input>
        </div>
        <div class="item">
          <div class="div">租完买断比例%:</div>
          <el-input v-model="val"  placeholder="请输入租完买断比例"></el-input>
        </div>
        <div class="item">
          <div class="div">租完即送比例%:</div>
          <el-input v-model="value" placeholder="请输入租完即送比例"></el-input>
        </div>
        <el-button type="primary" @click="add">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
export default {
  components: {

  },
  data() {
    return {
      lease_time:'12',
      val:'100',
      value:'100'
    };
  },
  inject: ['form'],
  created() {
    console.log(this.form.model.tableData[0],"this.form.model");
  },
  methods: {
    add(){
      if(this.lease_time != '' || this.val != ''){
        this.form.model.tableData.push({'lease_time':this.lease_time,'val':this.val,'value':this.value})
        this.lease_time = '';
        this.val = '';
        this.value = '';
      }else{
        this.$message({
          message: '请填写租赁天数及比例',
          type: 'error'
        });
      }
    },
    handleClick(row){
      if( this.form.model.tableData.length <= 1){
        this.$message({
              message: '该数据无法删除，必须保留一项',
              type: 'error'
            });
          return
      }
      if(row.product_stage_id != undefined){
        PorductApi.delLeaseTime({
          id:row.product_stage_id
        }).then(res=>{
          this.form.model.tableData.splice(row,1)
        })
      }else{
        // 前端删除
         this.form.model.tableData.splice(row,1)
      }
    }
  }
};
</script>

<style>
.addfenqi {
  height: 600px;
}
.intext{
  display: flex;
  align-items: center;
  margin-top: 50px;
}
.intext .item{
  display: flex;
  align-items: center;
}
.intext .item .div{
  width: 140px;
}
.item{
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product_1/part/fenqi.vue